import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Country, CustomerDetails, ShippingAddress } from '../../interfaces';
import { HARDCOPY_COUNTRIES, HARDCOPY_DEFAULT_COUNTRY } from '../../settings';
import { HardcopyPostageCostPage } from '../postage-cost/postage-cost';
import _ from 'lodash';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';

@Component({
    selector: 'page-shipping-address',
    templateUrl: 'shipping-address.html'
})

export class HardcopyShippingAddressPage {

    public formGroup: FormGroup;

    public customerDetails: CustomerDetails = null;
    public shippingAddress: ShippingAddress = {
        address1: '',
        address2: '',
        address3: '',
        country: HARDCOPY_DEFAULT_COUNTRY,
        name: '',
        postcode: '',
    };
    public countries = HARDCOPY_COUNTRIES;
    public qty: number = 1;
    public saveCallback: (shippingAddress: ShippingAddress) => void;
    public editMode: boolean = false;

    public get country(): Country {
        let _default = null;
        for (let country of this.countries) {
            if (country.id == HARDCOPY_DEFAULT_COUNTRY) _default = country;
            if (country.id == this.shippingAddress.country) return country;
        }
        return _default;
    }

    public set country(country: Country) {
        this.shippingAddress.country = country.id;
        this.formGroup.get('postcode').updateValueAndValidity();
    }

    constructor(
        public alertCtrl: AlertController,
        public analytics: FirebaseAnalytics,
        public formBuilder: FormBuilder,
        public navCtrl: NavController,
        public navParams: NavParams,
    ) {
        this.formGroup = this.formBuilder.group({
            name: ['', [Validators.required]],
            address1: ['', [Validators.required]],
            address2: ['', []],
            address3: ['', []],
            country: ['', []],
            postcode: ['', [this.requiredForCountryIds(['GBR'])]],
        });

        this.editMode = navParams.get('editMode') || false;

        if (this.editMode) {
            this.saveCallback = navParams.get('saveCallback');
            this.shippingAddress = Object.create(navParams.get('shippingAddress'));
        }

        this.customerDetails = navParams.get('customerDetails');
        this.qty = navParams.get('qty');
    }

    public ionViewDidEnter() {
        this.analytics.setCurrentScreen('HardcopyShippingAddress');
        this.analytics.logEvent('checkout_progress', {
            checkout_step: 3
        });
    }

    public requiredForCountryIds(countryIds: string[]) {
        return (control: AbstractControl): { [key: string]: any } | null => {
            return countryIds.indexOf(this.country.id) >= 0 ? Validators.required(control) : null;
        };
    }

    public next() {
        if (!this.formGroup.valid) return this.showValidationErrors();

        this.navCtrl.push(HardcopyPostageCostPage, {
            customerDetails: this.customerDetails,
            qty: this.qty,
            shippingAddress: this.shippingAddress,
        });
    }

    public save() {
        if (!this.formGroup.valid) return this.showValidationErrors();

        if (this.saveCallback) this.saveCallback(this.shippingAddress);

        this.navCtrl.pop();
    }

    public showValidationErrors() {
        _.forEach(this.formGroup.controls, control => {
            control.markAsDirty();
            control.markAsTouched();
        });

        let alert = this.alertCtrl.create({
            title: 'Something isn\'t right',
            message: 'Please check the information you have entered',
            buttons: [{
                text: 'OK',
            }]
        });

        alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/pages/shipping-address/shipping-address.ts